export default {
  formType: 'LABELING_TOOL_GRAPHICS',
  settings: {
    labelSourceSection: 'polygon',
    labelSourceField: 'type',
  },
  data: {
    // 模块
    block: [
      {
        fieldName: 'id',
        label: '块ID',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: true,
      },
    ],
    area: [
      {
        fieldName: 'name',
        label: '名称',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'position_mode',
        label: '融合定位模式',
        dataType: 'string',
        inputMethod: 'select',
        default: '0',
        disabled: false,
        options: [
          {
            value: '0',
            label: '无',
          },
          {
            value: '1',
            label: 'Beacon楼层+视觉',
          },
          {
            value: '2',
            label: 'Beacon位置+视觉',
          },
          {
            value: '3',
            label: 'Beacon 位置',
          },
        ],
      },
      {
        fieldName: 'type',
        label: '类型',
        dataType: 'string',
        inputMethod: 'select',
        default: '0',
        disabled: false,
        options: [
          {
            value: '0',
            label: 'Mall',
          },
          {
            value: '1',
            label: '停车场',
          },
          {
            value: '2',
            label: '人行坡道',
          },
          {
            value: '3',
            label: '上行坡道',
          },
          {
            value: '4',
            label: '下行坡道',
          },
          {
            value: '5',
            label: '走廊',
          },
          {
            value: '6',
            label: '室内外切换',
          },
          {
            value: '7',
            label: '室外',
          },
          {
            value: '8',
            label: '禁止楼层切换',
          },
          {
            value: '9',
            label: '隔离区内',
          },
          {
            value: '10',
            label: '隔离区外',
          },
          {
            value: '11',
            label: '国际隔离区内',
          },
        ],
      },
      {
        fieldName: 'show_type',
        label: '选择展示内容',
        dataType: 'string',
        inputMethod: 'select',
        default: '0',
        disabled: false,
        options: [
          {
            value: '0',
            label: '无',
          },
          {
            value: '1',
            label: '图片',
          },
          {
            value: '2',
            label: '全程VR',
          },
          {
            value: '3',
            label: '仅路口显示VR',
          },
        ],
      },
      {
        fieldName: 'image_url',
        label: '',
        dataType: 'string',
        inputMethod: 'imageUpload',
        default: '',
        disabled: false,
        bindings: [
          {
            show_type: '1',
          },
        ],
      },
      {
        // TODO 添加一个关联区域关联商官数据
        fieldName: 'area_id',
        label: '关联区域',
        dataType: 'number',
        inputMethod: 'cascader',
        default: '0',
        disabled: false,
        props: {
          props: {
            expandTrigger: 'hover',
            value: 'leafId',
            label: 'areaName',
            emitPath: false,
          },
          options: [],
        },
      },
    ],
    point: [
      {
        fieldName: 'block_id',
        label: '关联块ID',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'graphical_id',
        label: '关联图形ID',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'type',
        label: '类型',
        dataType: 'string',
        inputMethod: 'select',
        default: '0',
        disabled: false,
        options: [
          {
            value: '0',
            label: '无',
          },
          {
            value: '1',
            label: '店铺',
          },
          {
            value: '15',
            label: '车位',
          },
          {
            value: '3',
            label: '公共设施',
          },
          {
            value: '6',
            label: '坡道',
          },
          {
            value: '11',
            label: '车位与道路连接点',
          },
          {
            value: '12',
            label: '十字路口',
          },
          {
            value: '13',
            label: '区域中心',
          },
          {
            value: '18',
            label: '地图连接点',
          },
          {
            value: '2',
            label: '电梯楼梯',
          },
          {
            value: '4',
            label: '大屏设备',
          },
          {
            value: '16',
            label: '停车场入口',
          },
          {
            value: '30',
            label: '国内登机口',
          },
          {
            value: '31',
            label: '国际登机口',
          },
          {
            value: '32',
            label: '国内中转台',
          },
          {
            value: '33',
            label: '国际中转台',
          },
          {
            value: '34',
            label: '中转台',
          },
          {
            value: '35',
            label: '到达口',
          },
          {
            value: '36',
            label: '夜间出口',
          },
          {
            value: '39',
            label: '代客泊车',
          },
          {
            value: '40',
            label: '扶贫展销',
          },
          {
            value: '41',
            label: '公交车站',
          },
          {
            value: '42',
            label: '海岸会',
          },
          {
            value: '44',
            label: '停车缴费',
          },
          {
            value: '46',
            label: '行李寄存',
          },
          {
            value: '48',
            label: '自主贩卖机',
          },
          {
            value: '49',
            label: '自主交费区',
          },
          {
            value: '50',
            label: '艺术品',
          },
          {
            value: '51',
            label: '商场出入口',
          },
          {
            value: '52',
            label: '停车场LED指示屏',
          },
        ],
      },
      {
        fieldName: 'category_2',
        label: '电梯是',
        dataType: 'string',
        inputMethod: 'select',
        default: '',
        disabled: false,
        bindings: [
          {
            type: '2',
          },
        ],
        options: [
          {
            value: '1',
            label: '步行梯',
          },
          {
            value: '2',
            label: '直梯',
          },
          {
            value: '3',
            label: '双向扶梯',
          },
          {
            value: '4',
            label: '上行扶梯',
          },
          {
            value: '5',
            label: '下行扶梯',
          },
          {
            value: '6',
            label: '扶梯出口',
          },
        ],
      },
      {
        fieldName: 'is_pay_card',
        label: '是否刷卡',
        dataType: 'string',
        inputMethod: 'select',
        default: '0',
        disabled: false,
        bindings: [
          {
            type: '2',
          },
        ],
        options: [
          {
            value: '1',
            label: '是',
          },
          {
            value: '0',
            label: '否',
          },
        ],
      },
      {
        fieldName: 'building',
        label: '所属楼栋',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
        bindings: [
          {
            type: '2',
          },
        ],
      },
      {
        fieldName: 'category_3',
        label: '公共设施是',
        dataType: 'string',
        inputMethod: 'select',
        default: '',
        disabled: false,
        bindings: [
          {
            type: '3',
          },
        ],
        options: [
          {
            value: '1',
            label: '洗手间',
          },
          {
            value: '2',
            label: '服务台',
          },
          {
            value: '3',
            label: '其他',
          },
          {
            value: '4',
            label: '空车位区域',
          },
          {
            value: '5',
            label: '电梯区域',
          },
          {
            value: '6',
            label: '新能源区域',
          },
          {
            value: '7',
            label: '出口区域',
          },
          {
            value: '8',
            label: '洗车区域',
          },
          {
            value: '9',
            label: '母婴室',
          },
          {
            value: '10',
            label: '充电宝服务',
          },
          {
            value: '11',
            label: '无障碍卫生间',
          },
          {
            value: '12',
            label: '婴儿车租借',
          },
          {
            value: '13',
            label: '口罩服务',
          },
          {
            value: '52',
            label: '会员中心',
          },
          {
            value: '53',
            label: '寄存柜',
          },
          {
            value: '100',
            label: '客服中心',
          },
          {
            value: '101',
            label: '付费区',
          },
          {
            value: '102',
            label: '自助售票机',
          },
          {
            value: '103',
            label: 'A出口',
          },
          {
            value: '104',
            label: '非付费区',
          },
          {
            value: '105',
            label: '监察亭',
          },
          {
            value: '106',
            label: 'AED自动体外除颤器',
          },
          {
            value: '107',
            label: '闸机',
          },
          {
            value: '108',
            label: '入口',
          },
          {
            value: '109',
            label: '车厢门号',
          },
          {
            value: '110',
            label: 'D出口',
          },
          {
            value: '111',
            label: '第三卫生间',
          },
          {
            value: '112',
            label: '入口安检',
          },
          {
            value: '113',
            label: '绿色通道',
          },
          {
            value: '114',
            label: '深圳通自助售卡充值',
          },
          {
            value: '115',
            label: '自助票务处理设备',
          },
          {
            value: '116',
            label: '去往5号线',
          },
          {
            value: '117',
            label: '男洗手间',
          },
          {
            value: '118',
            label: '女洗手间',
          },
          {
            value: '119',
            label: '小火车站',
          },
          {
            value: '120',
            label: '地铁口',
          },
          {
            value: '121',
            label: '水幕盒子',
          },
          {
            value: '122',
            label: '生机之塔',
          },
        ],
      },
      {
        fieldName: 'category_6',
        label: '坡道类型是',
        dataType: 'string',
        inputMethod: 'select',
        default: '',
        disabled: false,
        bindings: [
          {
            type: '6',
          },
        ],
        options: [
          {
            value: '1',
            label: '上行坡道',
          },
          {
            value: '2',
            label: '下行坡道',
          },
          {
            value: '3',
            label: '坡道出口',
          },
          {
            value: '4',
            label: '坡道连接点',
          },
        ],
      },
      {
        fieldName: 'screen_angle',
        label: '大屏角度',
        dataType: 'string',
        inputMethod: 'input',
        default: 20,
        disabled: false,
        bindings: [
          {
            type: '4',
          },
        ],
      },
      {
        fieldName: 'line_length',
        label: '路径长度',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
        bindings: [
          {
            type: '4',
          },
        ],
      },
      {
        fieldName: 'pano_id',
        label: '全景点位ID',
        dataType: 'number',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'store_id',
        label: 'POI关联ID',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
        // bindings: [
        //   {
        //     type: '1',
        //   },
        // ],
      },
      {
        fieldName: 'external_store_id',
        label: '千目店铺code',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
        bindings: [
          {
            type: '1',
          },
        ],
      },
      {
        fieldName: 'name',
        label: '名称',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'level',
        label: 'poi优先级',
        dataType: 'number',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      // {
      //   fieldName: 'screen_direction',
      //   label: '朝向点x;y;z;panid',
      //   dataType: 'string',
      //   inputMethod: 'input',
      //   default: '',
      //   disabled: false,
      // },
      {
        fieldName: 'screen_direction_pos',
        label: '朝向点x;y;z',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'screen_direction_pid',
        label: '朝向点panid',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'screen_pointer',
        label: '大屏拐角标识绑定',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'screen_end',
        label: '大屏终点绑定',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'intersection_name',
        label: '路口名称',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
    ],
    // 全景点配置
    PanoramaPoint: [
      {
        fieldName: 'pano_id',
        label: '全景点位ID',
        dataType: 'number',
        inputMethod: 'input',
        default: '',
        disabled: true,
      },
      {
        fieldName: 'seq_id',
        label: 'seq_id',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: true,
      },
      {
        fieldName: 'is_route',
        label: '是否为路口点',
        dataType: 'string',
        inputMethod: 'select',
        default: '',
        disabled: false,
        options: [
          {
            value: '0',
            label: '是',
          },
          {
            value: '1',
            label: '否',
          },
        ],
      },
    ],
    // 大屏点配置
    Screen: [
      {
        fieldName: 'block_id',
        label: '关联块ID',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'type',
        label: '类型',
        dataType: 'string',
        inputMethod: 'select',
        default: '4',
        disabled: false,
        options: [
          {
            value: '4',
            label: '大屏',
          },
        ],
      },
      {
        fieldName: 'screen_angle',
        label: '大屏角度',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'pano_id',
        label: '全景点位ID',
        dataType: 'number',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'name',
        label: '名称',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
    ],
    // 直梯点配置
    Elevator: [
      {
        fieldName: 'block_id',
        label: '关联块ID',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'type',
        label: '类型',
        dataType: 'string',
        inputMethod: 'select',
        default: '2',
        disabled: false,
        options: [
          {
            value: '2',
            label: '直梯',
          },
        ],
      },
      {
        fieldName: 'category_2',
        label: '方向',
        dataType: 'string',
        inputMethod: 'select',
        default: '2',
        disabled: false,
        bindings: [
          {
            type: '2',
          },
        ],
        options: [
          {
            value: '2',
            label: '直梯',
          },
        ],
      },
      {
        fieldName: 'pano_id',
        label: '全景点位ID',
        dataType: 'number',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'name',
        label: '名称',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
    ],
    // 扶梯点配置
    Escalator: [
      {
        fieldName: 'block_id',
        label: '关联块ID',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'type',
        label: '类型',
        dataType: 'string',
        inputMethod: 'select',
        default: '2',
        disabled: false,
        options: [
          {
            value: '2',
            label: '扶梯',
          },
        ],
      },
      {
        fieldName: 'category_2',
        label: '方向',
        dataType: 'string',
        inputMethod: 'select',
        default: '',
        disabled: false,
        options: [
          {
            value: '1',
            label: '步行梯',
          },
          // {
          //   value: '2',
          //   label: '直梯',
          // },
          {
            value: '3',
            label: '双向扶梯',
          },
          {
            value: '4',
            label: '上行扶梯',
          },
          {
            value: '5',
            label: '下行扶梯',
          },
          {
            value: '6',
            label: '扶梯出口',
          },
        ],
      },
      {
        fieldName: 'pano_id',
        label: '全景点位ID',
        dataType: 'number',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'name',
        label: '名称',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
    ],
    // 多边形配置
    polygon: [
      {
        fieldName: 'block_id',
        label: '关联块ID',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'type',
        label: '类型',
        dataType: 'string',
        inputMethod: 'select',
        default: '1',
        disabled: false,
        options: [
          {
            value: '1',
            label: '车位',
          },
        ],
      },
      {
        fieldName: 'parking_id',
        label: '车位号',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
        bindings: [
          {
            type: '1',
          },
        ],
      },
      {
        fieldName: 'area_group',
        label: '所属区域',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
        bindings: [
          {
            type: '1',
          },
        ],
      },
      {
        fieldName: 'parking_group',
        label: '车组',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
        bindings: [
          {
            type: '1',
          },
        ],
      },
    ],
    // 线属性设置
    CommonLine: [
      {
        fieldName: 'parking_number',
        label: '相邻车位号',
        dataType: 'string',
        inputMethod: 'input',
        default: '',
        disabled: false,
      },
      {
        fieldName: 'path_direction',
        label: '通行方向',
        dataType: 'string',
        inputMethod: 'select',
        default: '',
        disabled: false,
        options: [
          {
            value: '',
            label: '请选择',
          },
          {
            value: 'twoward',
            label: '双向车道',
          },
          {
            value: 'forward',
            label: '正向车道',
          },
          {
            value: 'backward',
            label: '反向车道',
          },
          {
            value: 'forward_direction',
            label: '正向通行',
          },
          {
            value: 'backward_direction',
            label: '反向通行',
          },
        ],
      },
    ],
  },
};
